import "core-js/modules/es.promise.js";
export const awaitablePromise = promise => new Promise(resolve => {
  promise.then(result => {
    resolve(result);
  }).catch(e => {
    resolve({
      error: e
    });
  });
});